const CommitDoc = () => import('./CommitDoc.vue')
const DocModule = () => import('./DocModule.vue')
const ModuleDetail = () => import('./ModuleDetail.vue')
const SubDoc = () => import('./SubDoc.vue')
const ServiceOrder = () => import('./ServiceOrder.vue')
const Lawsuit = () => import('./Lawsuit.vue')
const LawyerLetter = () => import('./LawyerLetter.vue')
const MeetConsult = () => import('./MeetConsult.vue')
const DraftDoc = () => import('./DraftDoc.vue')

export {
  CommitDoc,
  DocModule,
  ModuleDetail,
  SubDoc,
  ServiceOrder,
  Lawsuit,
  LawyerLetter,
  MeetConsult,
  DraftDoc
}



// WEBPACK FOOTER //
// ./src/pages/doc/index.js